export enum TransactionTypes {
    GET_TRANSACTIONS_LOADING = "GET_TRANSACTIONS_LOADING",
    GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS",
    GET_TRANSACTIONS_FAILURE = "GET_TRANSACTIONS_FAILURE",
    CLEAR_TRANSACTIONS_SUCCESS = "CLEAR_TRANSACTIONS_SUCCESS",
}
